import { Children } from 'react';
import CollapsibleHeader from './collapsible-header';
import CollapsibleContent from './collapsible-content';
import CollapsibleFooter from './collapsible-footer';
/* eslint-disable unicorn/no-fn-reference-in-iterator */
export var getHeaderContent = function (children) {
    var headerContent = null;
    if (!children) {
        return null;
    }
    Children.forEach(children, function (child) {
        if (child && child.type === CollapsibleHeader) {
            headerContent = child && child.props && child.props.children;
            return headerContent;
        }
    });
    return headerContent;
};
export var getBodyContent = function (children) {
    var bodyContent = null;
    if (!children) {
        return null;
    }
    Children.forEach(children, function (child) {
        if (child && child.type === CollapsibleContent) {
            bodyContent = child && child.props && child.props.children;
            return bodyContent;
        }
    });
    return bodyContent;
};
export var getFooterContent = function (children) {
    var footerContent = null;
    if (!children) {
        return null;
    }
    Children.forEach(children, function (child) {
        if (child && child.type === CollapsibleFooter) {
            footerContent = child && child.props && child.props.children;
            return footerContent;
        }
    });
    return footerContent;
};
/* eslint-enable unicorn/no-fn-reference-in-iterator */
export var isFunction = function (item) {
    return item && typeof item === 'function';
};
